export default __webpack_public_path__ + "static/media/IMG-20250105-WA0019.9acb1a7d.jpg";